/**
 * Adiciona bordas a todas as tabelas e destaca células de cabeçalho (gravata).
 */
export function processHtmlWithTableBorders(html) {
  if (!html) return html
  try {
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')

    doc.querySelectorAll('table').forEach((table) => {
      table.style.borderCollapse = 'collapse'
      table.style.width = '100%'
      table.style.marginTop = '8px'
      table.style.marginBottom = '8px'
    })

    doc.querySelectorAll('td, th').forEach((cell) => {
      cell.style.border = '1px solid #ccc'
      cell.style.padding = '4px 8px'
      cell.style.verticalAlign = 'top'
    })

    doc.querySelectorAll('th').forEach((th) => {
      th.style.backgroundColor = '#e8eaf6'
      th.style.fontWeight = 'bold'
    })

    doc.querySelectorAll('.gravata, [class*="gravata"], .thead, .table-header').forEach((cell) => {
      cell.style.backgroundColor = '#e8eaf6'
      cell.style.fontWeight = 'bold'
    })

    return doc.body.innerHTML
  } catch (e) {
    return html
  }
}

/**
 * Remove todas as tags <a>, mantendo o conteúdo interno.
 */
export function removeLinks(html) {
  if (!html) return html
  try {
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')
    doc.querySelectorAll('a').forEach((a) => {
      const parent = a.parentNode
      while (a.firstChild) {
        parent.insertBefore(a.firstChild, a)
      }
      parent.removeChild(a)
    })
    return doc.body.innerHTML
  } catch (e) {
    return html.replace(/<a[^>]*>/gi, '').replace(/<\/a>/gi, '')
  }
}



// WEBPACK FOOTER //
// ./src/utils/htmlUtils.js